export default "__VITE_ASSET__a7EFaU7I__"